import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import es from '../../lang/es';

const ListSearch = ({ filter, setFilter, handleSearch, jurisdictions, paymentTypes, paymentStates }) => {
     //Función que toma cambios
     const handleChange = e => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        })
    }
    //Render
    return (
        <form className="col-12" onSubmit={handleSearch}>
            <div className="row">
                <div className="col-lg-2 form-group">
                    <input 
                        type="text" 
                        className="form-control" 
                        name="number"
                        onChange={handleChange}
                        value={filter.number}
                        autoFocus 
                        placeholder={ es.FIELDS.NUMBER }
                    />
                </div>
                <div className="col-lg-2 form-group">
                    <input 
                        type="text" 
                        className="form-control"
                        name="cover"
                        onChange={handleChange}
                        value={filter.cover}
                        placeholder={ es.FIELDS.COVER }
                    />
                </div>
                <div className="col-lg-3 form-group">
                    <select name="jurisdiction" className="form-control" onChange={handleChange} value={filter.jurisdiction}>
                        <option value="">{ es.SELECT.JURISDICTIONS }</option>
                        {
                            jurisdictions ? (
                                jurisdictions.map( jurisdiction => (
                                    <option value={jurisdiction.id} key={`jo${jurisdiction.id}`}>
                                        { jurisdiction.description }
                                    </option>
                                ))
                            ) : null
                        }
                    </select>
                </div>
                <div className="col-lg-2 form-group">
                    <select name="state" className="form-control" onChange={handleChange} value={filter.state}>
                        <option value="">{ es.SELECT.PAYMENT_STATES }</option>
                        {
                            paymentStates ? (
                                paymentStates.map( paymentState => (
                                    <option value={paymentState.id} key={`pso${paymentState.id}`}>
                                        { paymentState.name }
                                    </option>
                                ))
                            ) : null
                        }
                    </select>
                </div>
                <div className="col-lg-2 form-group">
                    <select name="type" className="form-control" onChange={handleChange} value={filter.type}>
                        <option value="">{ es.SELECT.PAYMENT_TYPES }</option>
                        {
                            paymentTypes ? (
                                paymentTypes.map( paymentType => (
                                    paymentType.is_parent ? (
                                        <option value={paymentType.id} key={`pto${paymentType.id}`}>
                                            { paymentType.name }
                                        </option>
                                    ) : null
                                ))
                            ) : null
                        }
                    </select>
                </div>
                <div className="col-lg-1 form-group">
                    <button 
                        className="btn btn-block btn-primary" 
                        data-toggle="tooltip" 
                        title={ es.SEARCH } 
                        data-placement="left" 
                        type="submit"
                    >
                        <FontAwesomeIcon icon={faSearch} />
                    </button>
                </div>
            </div>
        </form>
    );
};

export default ListSearch;